/**
 * "HAS NO PROFILE PICTURE" — read off the URL, in one place
 *
 * There is no `hasAvatar` boolean on the wire. `avatarObject()`
 * (`backend/src/http/serialize.ts`) answers with three concrete URLs either
 * way: the upload renditions when `users.avatar_upload_id` is set, and
 * `/api/v1/media/letter-avatars/{letter}/{size}.png` when it is null. So the
 * URL SHAPE is the only signal a client has, and every surface that wants to
 * know "is this a real photo?" has to recognise it.
 *
 * BOTH SPELLINGS, BECAUSE ONLY ONE OF THEM IS DISCOURSE'S. Migrated rows still
 * carry Discourse's underscored `/images/letter_avatar/…`; the backend that
 * replaced it mints the HYPHENATED `/media/letter-avatars/…`. Matching only
 * the underscored form is exactly OSO-453: `ui/Avatar` stopped recognising
 * anything the live wire carried and fetched the server-rendered PNG instead
 * of drawing its own initials — while `ProfileCompletionNudge`, which had the
 * same predicate written out a second time, had it right. Two copies, one of
 * them stale, is how that bug happened; hence one function.
 *
 * A real upload is `/api/v1/media/{id}/{variant}`, so the substring cannot
 * collide with one: an uploaded file's own name never reaches the URL.
 *
 * THE RIGHT FIX IS ON THE SERVER — it should say "no picture" outright rather
 * than leave the client to infer it from an address. That is an /api/v1
 * contract change and is tracked separately (OSO-480). When it lands, this
 * module is what it deletes.
 */

/**
 * True when the URL is a generated letter avatar — i.e. the person has not
 * uploaded a picture. A missing URL counts as "no picture" too.
 */
export function isLetterAvatarUrl(url: string | null | undefined): boolean {
  return !url || /letter[-_]avatar/.test(url);
}
